import { Fragment } from 'react'

function Chip ({ color, text, openGame }) {
    if(openGame){
        return (
            <Fragment>
                <div className={`antialiased uppercase text-xs font-medium bg-${color}-400 px-2 py-0.5 rounded shadow-2xl`}>{text}</div>
            </Fragment>
        )
    } else {
        return null
    }
}

export default Chip